export default {
    Metadata: {
        Name: "Char",
        Description: "Returns the string character for the Ascii code specified.",
        Syntax: "Char(number)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(charCode) {
        return String.fromCharCode(charCode);
    },
};

